import React from 'react';
import { required, useRecordContext, useTranslate } from 'react-admin';
import resourceSlug from '../../../../constant/resource-slug';
import ResetOnFieldChange from '../../../../base/components/customized/ResetOnFieldChange';
import ReferenceInput from '../../../../base/components/ra/inputs/reference.input';
import { AutocompleteInput } from '../../../../base/components/ra/inputs';
import { useAuthUser, useQueryParams } from '../../../../base/hooks';

const GroupInput = (props) => {
  const t = useTranslate();
  const { groupId } = useQueryParams();
  const user = useAuthUser();
  const record = useRecordContext();

  const disabled = Boolean(groupId || user.group?.id || record?.id);

  return (
    <>
      <ReferenceInput
        validate={required(t('ra.validation.required'))}
        reference={resourceSlug.GROUP}
        source="group"
        format={(data) => data?.id}
        filterToQuery={(value) => ({
          'name||$cont': value || '',
          enabled: true,
        })}
        disabled={disabled}
        parse={(id) => ({
          id,
        })}
        resettable={!disabled}
        {...props}
      >
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      {!disabled && <ResetOnFieldChange watchField="group" resetFields={['currenciesConfig', 'features']} />}
    </>
  );
};

export default GroupInput;
